import React, { useState, useEffect, Fragment } from "react";
import {
  Table,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  FormFeedback,
  Form,
  Input
} from "reactstrap";
import * as Yup from 'yup';
import { useFormik } from "formik";
import { Link } from "react-router-dom";
import Select from "react-select";
import { useSelector, useDispatch } from "react-redux";
import { map } from "lodash";
import "flatpickr/dist/themes/material_blue.css";
import RequestServiceCancelModal from "./RequestServiceCancelModal";
import BreadcrumbLink from "../../components/Common/BreadcrumbLink";
import i18n from "../../i18n";
import { listStatus, listType, listPlaces } from "../../common/data";
import Spinners from "../../components/Common/Spinner";
import CardService from "./CardService";
import PaginationV2 from "../../components/Pagination/PaginationV2";
import { WebsocketService } from "./WebsocketService";
import { getOrgsAdmin } from "../../helpers/api_rombo_helper";
import AlertSuccess from "../../components/Alerts/AlertSuccess";
import { createSelector } from "reselect";
import { FilterType, AlertMessages, StreamType, TypeService, Permissions, DataActions } from "../../constants/enums";
import { getFromLocalStorage, saveToLocalStorage } from "../../constants/storage";
import { orgId, handleSearchFilters } from "../../constants/utils";

const ServicesAssignment = () => {
  document.title = `${i18n.t("Assignment")} - ${orgId}`;

  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(true);
  const [reloadList, setReloadList] = useState(true);
  const [drp_link, setDrp_link] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [findServices, setFindServices] = useState([]);
  const [listServices, setListServices] = useState({ page: 1, size: 10, pages: 1, items: [] });
  const [assignServices, setAssignServices] = useState([]);
  const [infoUser, setInfoUser] = useState({ permissions: [] });
  const [requestServiceCancelModal, setRequestServiceCancelModal] = useState(false);

  const toggleViewModalCancelService = () => setRequestServiceCancelModal(!requestServiceCancelModal);
  const [showAlertSuccess, setShowAlertSuccess] = useState(false);
  const [clickAssignService, setClickAssignService] = useState(true);
  const [textHeader, setTextHeader] = useState('');
  const [textBody, setTextBody] = useState('');
  const [listCompanies, setListCompanies] = useState([]);
  const [selectedService, setSelectedService] = useState({});

  const savedFilters = JSON.parse(localStorage.getItem("assignmentFilters")) || { data: { filters: {} } };

  const [fCompany, setFCompany] = useState(savedFilters.data?.filters?.partner_id || null);
  const [typeService, setTypeService] = useState(savedFilters.data?.filters?.type || null);
  const [statusService, setStatusService] = useState(savedFilters.data?.filters?.status || null);
  const [serviceNumber, setServiceNumber] = useState(savedFilters.data?.filters?.code || null);
  const [placeService, setPlaceService] = useState(savedFilters.data?.filters?.place_id || null);

  const [currentPage, setCurrentPage] = useState(savedFilters.data?.filters?.page || 1);
  const [recordsPerPage] = useState(7);
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const [currentRecords, setCurrentRecords] = useState(findServices.slice(indexOfFirstRecord, indexOfLastRecord));
  const nPages = Math.ceil(findServices.length / recordsPerPage);
  
  const [filtersOpts, setFiltersOpts] = useState({
    eventType: "sendMessage",
    metadata: { platform: "WEB", screen: "ASSIGNMENT" },
    data: { action: DataActions.GET_BOOKINGS, filters: { page: 1, size: 10 } }
  });
 
  const autoformik = useFormik({
    initialValues: {
      search: "",
      serviceNumber: "",
      status: "",
      type: "",
      place_id: "",
    },
    validationSchema: Yup.object({
      search: Yup.string(),
      serviceNumber: Yup.string(),
      status: Yup.string(),
      type: Yup.string(),
      place_id: Yup.string(),
    })
  });

  const LoginProperties = createSelector(
    (state) => state.Login,
    (Login) => ({
      token: Login.token,
      loading: Login.loading,
      data: Login.data
    })
  );

  const { token, loading, data } = useSelector(LoginProperties);

  useEffect(() => {
    const savedFilters = getFromLocalStorage("assignmentFilters");
    if (savedFilters && typeof savedFilters === 'object') {
      setFiltersOpts(savedFilters);
      setCurrentPage(savedFilters.data?.filters?.page || 1);
    } else {
      setFiltersOpts({
        eventType: "sendMessage",
        metadata: { platform: "WEB", screen: "ASSIGNMENT" },
        data: { action: DataActions.GET_BOOKINGS, filters: { page: 1, size: 10 } }
      });
    }
  }, []);

  useEffect(() => {
    try {
      const assignmentFilters = localStorage.getItem("assignmentFilters");
      if (assignmentFilters && !assignmentFilters.startsWith('{')) {
        localStorage.removeItem("assignmentFilters");
      }
    } catch (error) {
      console.error("Error clearing localStorage:", error);
    }
  }, []);

  useEffect(() => {
    if (data?.data) {
      setInfoUser(data.data);
      
      if (!data.data.is_staff) {
        searchFilters(data.data.partner_id, "company");
      }
    }
  }, [data, loading]);
  
  useEffect(() => {
    if(data?.data){
      setInfoUser(data.data)
    }
  }, [data, loading]);

  useEffect(() => {
    setFindServices(listServices.items);
  }, [listServices]);
  
  const searchFilters = (val, typeSearch) => {
    handleSearchFilters(
      val,
      typeSearch,
      filtersOpts,
      setFiltersOpts,
      setReloadList,
      setCurrentPage,
      "assignmentFilters",
      {
        setFCompany,
        setStatusService,
        setTypeService,
        setServiceNumber,
        setPlaceService
      }
    );
  };

  const onGetOrgsAdmin = () => {
    let arr = [];
    getOrgsAdmin(token)
      .then((response) => {
        response.forEach((item) => {
          arr.push({ label: item.name, value: item.partner_id });
        });
        setListCompanies([...arr]);
      })
      .catch((error) => {
        console.error("Error - onGetOrgsAdmin - ", error);
      });
  };

  useEffect(() => {
    onGetOrgsAdmin();
    
    const notifyStatus = getFromLocalStorage("notify");
    const headerText = getFromLocalStorage("headerText") || AlertMessages.SUCCESS;
    const bodyText = getFromLocalStorage("bodyText");

    if (notifyStatus === "true") {
        setShowAlertSuccess(true);
        setTextHeader(headerText);
        setTextBody(bodyText);
        saveToLocalStorage("notify", "false");
    }
}, [dispatch]);

  const onClickAssignService = (args, type, e) => {
  let onAssignServices = [];

    if (type === "one") {
      if (e.target.checked) {
    setAssignServices(prevServices => {
            if (!prevServices.some(opt => opt.code === args.code)) {
                    const updatedServices = [...prevServices, args];
                    saveToLocalStorage("services", updatedServices.length ? updatedServices : null);
                    return updatedServices;
                }
                return prevServices;
            });
        } else {
          setAssignServices(prevServices => {
                const updatedServices = prevServices.filter(opt => opt.code !== args.code);
          saveToLocalStorage("services", updatedServices.length ? updatedServices : null);
      return updatedServices;
    });
  }
    } else {
  if (e.target.checked) {
            let arrFindServices = [];
          
            findServices.forEach(item => {
                if (!onAssignServices.some(opt => opt.code === item.code)) {
                    arrFindServices.push(item);
                }
                const checkbox = document.getElementById(`check-${item.code}`);
                if (checkbox) checkbox.checked = true;
            });
          
            const newAssignedServices = [...onAssignServices, ...arrFindServices];
            setAssignServices(newAssignedServices);
            saveToLocalStorage("services", newAssignedServices.length ? newAssignedServices : null);

        } else {
            findServices.forEach(item => {
                const checkbox = document.getElementById(`check-${item.code}`);
                if (checkbox) checkbox.checked = false;
            });
      setAssignServices([]);
      saveToLocalStorage("services", null);
  }
    }
  };

  return (
    <Fragment>
      <div className="page-content">
        <div className="container-fluid">
        <BreadcrumbLink title={i18n.t("Services")} link='/services/assignment' breadcrumbItem={i18n.t("Assignment")} />
          <Row>
            <Card>
	            <CardBody>
                <Row className="pb-2">
                 <Col xxl={9} md={7} xs={12}>
                   <CardTitle className="h4">{i18n.t("RequestsToBeAssigned")}</CardTitle>
                 </Col>
                 <Col xxl={3} md={5} xs={12} className="text-end">
                   <Row>
                     <Col xxl={12} md={12} xs={12}>
                        {assignServices.length == 0 ? (
                          <button disabled={true} className="btn btn-request">
                            {i18n.t("AssignAService")}
                          </button>
                        ) : (
                          infoUser.permissions.includes(Permissions.DRIVER_WRITE) && (
                            <Link to="/services/assignment/create" className="btn btn-request">
                              {i18n.t("AssignAService")}
                            </Link>
                          )
                        )}
                     </Col>
                   </Row>
                 </Col>
                </Row>
                <div className="orange-separator" />
                <Row className="pb-2">
                  <Form className="row gx-3" onSubmit={autoformik.handleSubmit}>
                    {infoUser.is_staff && (
                      <Col xxl={3} md={3} xs={12}>
                        <Card className="mb-2">
                          <Select
                            name="company"
                            placeholder={i18n.t("SelectPartnerName")}
                            options={listCompanies}
                            isClearable
                            className="select2-selection"
                            value={listCompanies.find((item) => item.value === fCompany) || null}
                            onChange={(e) => {
                              searchFilters(e?.value || null, FilterType.COMPANY);
                            }}
                          />
                        </Card>
                      </Col>
                    )}
                    <Col xxl={2} md={2} xs={12} className="mb-2">
                      <div className="col-sm-auto">
                        <div className={`floating-input ${isFocused || serviceNumber ? "active" : ""}`}>
                          <Input
                            type="text"
                            name="serviceNumber"
                            className="form-control"
                            id="serviceNumberInput"
                            value={serviceNumber || ""}
                            onChange={(e) => {
                              const value = e.target.value;
                              setServiceNumber(value);
                              searchFilters(value || null, FilterType.CODE);
                            }}
                            onBlur={autoformik.handleBlur}
                            invalid={
                              autoformik.touched.serviceNumber && autoformik.errors.serviceNumber
                                ? true
                                : false
                            }
                          />
                          <label htmlFor="serviceNumberInput">
                            {i18n.t("ID")}
                          </label>
                        </div>
                        {autoformik.errors.serviceNumber && autoformik.touched.serviceNumber ? (
                          <FormFeedback type="invalid">
                            {autoformik.errors.serviceNumber}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </Col>
                    <Col xxl={2} md={2} xs={12}>
                      <Card className="mb-2">
                        <Select
                          name="status"
                          placeholder={i18n.t("Status")}
                          options={listStatus()}
                          isClearable
                          className="select2-selection"
                          value={listStatus().find((item) => item.value === statusService) || null}
                          onChange={(e) => {
                            searchFilters(e?.value || null, FilterType.STATUS);
                          }}
                        />
                      </Card>
                    </Col>
                    <Col xxl={2} md={2} xs={12}>
                      <Card className="mb-2">
                        <Select
                          name="type"
                          placeholder={i18n.t("Type")}
                          options={listType()}
                          isClearable
                          className="select2-selection"
                          value={listType().find((item) => item.value === typeService) || null}
                          onChange={(e) => {
                            searchFilters(e?.value || null, FilterType.TYPE);
                          }}
                        />
                      </Card>
                    </Col>
                    <Col xxl={2} md={2} xs={12} className="mb-2">
                      <div className="col-sm-auto">
                        <Select
                          name="place"
                          placeholder={i18n.t("Place")}
                          options={listPlaces()}
                          isClearable
                          className="select2-selection"
                          value={listPlaces().find((item) => item.value === placeService) || null}
                          onChange={(e) => {
                            searchFilters(e?.value || null, FilterType.PLACE);
                          }}
                        />
                        {autoformik.errors.placeService && autoformik.touched.placeService ? (
                          <FormFeedback type="invalid">
                            {autoformik.errors.placeService}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </Col>
                    <Col xxl={2} md={2} xs={2} className="">
                      {/* <DateRangePicker
	                      label="Date range"
                        defaultValue={{
                          start: parseZonedDateTime('2022-11-07T00:45[America/Los_Angeles]'),
                          end: parseZonedDateTime('2022-11-08T11:15[America/Los_Angeles]')
                      }} /> */}
                    </Col>
                  </Form>
                </Row>
                <div className="orange-separator" />
                <div className="table-responsive pt-3">
                  <Table className="table table-bordered mb-0 table-request-services">
                    <thead>
                      <tr>
                        <th>
                          <Input
                            type="checkbox"
                            id="checkAll"
                            className={`${clickAssignService ? "" : "d-none p-0 m-0"}`}
                            onClick={(e) => onClickAssignService(null, "all", e)}
                          />
                        </th>
                        {infoUser.is_staff && (
                          <th className="company-column">
                            {i18n.t("Company")}
                          </th>
                        )}
                        <th className="request-number-column">{i18n.t("ID")}</th>
                        <th className="origin-column">{i18n.t("Origin")}</th>
                        <th className="destination-column">{i18n.t("Destination")}</th>
                        {/* <th>{i18n.t("Passengers")}</th> */}
                        {/*<th>{i18n.t("Scales")}</th> */}
                        <th className="date-column">{i18n.t("Date")}</th>
                        <th className="hour-column">{i18n.t("Hour")}</th>
                        <th className="type-column">{i18n.t("Type")}</th>
                        <th className="type-column">{i18n.t("Place")}</th>
                        <th className="status-column">{i18n.t("Status")}</th>
                        <th className="actions-header">{i18n.t("Actions")}</th>
                      </tr>
                    </thead>
                    {
                      isLoading ? null : (
                        <tbody>
                          {map(findServices, (service, key) => (
                            <CardService
                              service={service}
                              infoUser={infoUser}
                              setSelectedService={setSelectedService}
                              typeService={TypeService.ASSIGNMENT}
                              setRequestServiceCancelModal={setRequestServiceCancelModal}
                              key={"_shop_" + key}
                              clickAssignService={clickAssignService}
                              onClickAssignService={onClickAssignService}
                            />
                          ))}
                        </tbody>
                      )
                    }
                  </Table>
                  <WebsocketService
                    setLoading={setLoading}
                    filtersOpts={filtersOpts}
                    uuid={infoUser.external_id}
                    listServices={listServices}
                    setListServices={setListServices}
                    reloadList={reloadList}
                    allowedActions={[StreamType.DRIVER_ONLINE, StreamType.DRIVER_OFFLINE]}
                  />
                  <RequestServiceCancelModal
                    token={token}
                    setReloadList={setReloadList}
                    reloadList={reloadList}
                    typeService={TypeService.ASSIGNMENT}
                    isOpen={requestServiceCancelModal}
                    toggle={toggleViewModalCancelService}
                    setRequestServiceCancelModal={setRequestServiceCancelModal}
                    setShowAlertSuccess={setShowAlertSuccess}
                    setTextHeader={setTextHeader}
                    setTextBody={setTextBody}
                    setSelectedService={setSelectedService}
                    selectedService={selectedService}
                  />
                  {isLoading ? (
                    <Spinners setLoading={setLoading} />
                  ) : (
                    infoUser.permissions.includes(Permissions.SERVICES_READ) && (
                      <PaginationV2
                        currentPage={currentPage}
                        pageSize={listServices.size}
                        totalItems={listServices.total}
                        onChangePage={(page) => {
                          setCurrentPage(page);
                          searchFilters(page, "page");
                        }}
                      />
                    )
                  )}
                </div>
              </CardBody>
            </Card>
          </Row>
          <AlertSuccess
            showAlertSuccess={showAlertSuccess}
            setShowAlertSuccess={setShowAlertSuccess}
            textHeader={textHeader}
            textBody={textBody}
          />
        </div>
      </div>
    </Fragment>
  );
};

export default ServicesAssignment;
